export default{

    MAXSIZE_BOOK_DESCRIPTION:50,
    MAXSIZE_BOOK_NAME:50,
    MAXSIZE_CERTIFICATE_SKILLS:3
}